/* Occasion pills on collection pages → navigate to occasion collection URLs.
   Synced with header anledningsbar (fb_occasion) for active state. */
(function () {
  'use strict';

  var STORAGE_KEY = 'fb_occasion';
  var OCC = {
    privat: ['Bryllup', 'Konfirmasjon', 'Dåp', 'Bursdag', 'Jubileum', 'Sommerfest', 'Annet'],
    bedrift: ['Firmafest', 'Julebord', 'Kickoff', 'Messe', 'Kundeevent', 'Idrett', 'Konferanse', 'Annet'],
  };

  /** Occasion slug aliases when collection handle differs from occasion name. */
  var OCC_SLUG_ALIAS = {
    sommerfest: 'sommer',
    julebord: 'jul',
    dap: 'dap',
    'daap': 'dap',
    annet: 'uspesifisert-noytralt',
  };

  /** Category segment inside photo-booth-* parent handles. */
  var CATEGORY_RE = /^(?:(.+)-)?photo-booth-(rekvisitter|ballonger|bakgrunner|bannere|rammer|skilt|konfetti|band|tilbehor)$/;

  function readGlobalOccasion() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; }
  }

  function writeGlobalOccasion(value, label) {
    try {
      if (!value) sessionStorage.removeItem(STORAGE_KEY);
      else sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ value: value, label: label || value }));
    } catch (e) {}
  }

  function sessionBooking() {
    try {
      return JSON.parse(sessionStorage.getItem('fb-min-booking') || 'null')
        || JSON.parse(sessionStorage.getItem('fb-tilvalg-booking') || 'null');
    } catch (e) { return null; }
  }

  function getAudience() {
    return document.body.dataset.fbAudience
      || (function () { try { return sessionStorage.getItem('fb_audience'); } catch (e) { return null; } })()
      || 'privat';
  }

  function occasionName(anledning) {
    var raw = String(anledning || '');
    var part = raw.indexOf('/') >= 0 ? raw.split('/').pop() : raw;
    return part.trim();
  }

  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/æ/g, 'ae')
      .replace(/ø/g, 'o')
      .replace(/å/g, 'a')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function collectionHandle(root) {
    var fromData = root.getAttribute('data-collection-handle');
    if (fromData) return fromData;
    var m = String(location.pathname || '').match(/\/collections\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function parseCategory(handle) {
    var m = String(handle || '').match(CATEGORY_RE);
    if (!m) return null;
    return {
      occasionSlug: m[1] || '',
      category: m[2],
      parentHandle: 'photo-booth-' + m[2],
    };
  }

  function occasionCollectionHandle(parentHandle, occasionLabel) {
    var parsed = parseCategory(parentHandle) || { parentHandle: parentHandle, category: '', occasionSlug: '' };
    var parent = parsed.parentHandle || parentHandle;
    if (!occasionLabel) return parent;

    var slug = slugify(occasionLabel);
    if (OCC_SLUG_ALIAS[slug]) slug = OCC_SLUG_ALIAS[slug];
    return slug + '-' + parent;
  }

  function occasionCollectionUrl(parentHandle, occasionLabel) {
    return '/collections/' + encodeURIComponent(occasionCollectionHandle(parentHandle, occasionLabel));
  }

  /**
   * Map of occasion-collection handle -> product count, rendered server-side
   * (snippet fb-occasion-availability). null = attribute missing (legacy markup).
   */
  function parseAvailability(root) {
    var attr = root.getAttribute('data-fb-occasion-available');
    if (attr === null) return null;
    var map = {};
    attr.split(',').forEach(function (pair) {
      pair = pair.trim();
      if (!pair) return;
      var i = pair.lastIndexOf(':');
      if (i < 0) return;
      map[pair.slice(0, i)] = parseInt(pair.slice(i + 1), 10) || 0;
    });
    return map;
  }

  function pillsForAudience(audience) {
    var opts = [];
    document.querySelectorAll('[data-fb-occasion-bar] [data-fb-occasion-value]').forEach(function (btn) {
      var scope = btn.dataset.fbOccasionAudience || 'all';
      if (scope !== 'all' && scope !== audience) return;
      var v = btn.dataset.fbOccasionValue;
      if (v && opts.indexOf(v) === -1) opts.push(v);
    });
    if (!opts.length) opts = (OCC[audience] || OCC.privat).slice();
    if (opts.indexOf('Annet') === -1) opts.push('Annet');
    return opts;
  }

  function resolveCurrent(occs, handle) {
    var parsed = parseCategory(handle);
    if (parsed && parsed.occasionSlug) {
      // Reverse alias: sommer → Sommerfest if that's in pill list
      var fromHandle = parsed.occasionSlug;
      var match = occs.find(function (o) {
        var s = slugify(o);
        return s === fromHandle || OCC_SLUG_ALIAS[s] === fromHandle;
      });
      if (match) return { value: match, label: match, source: 'url' };
      // jul → Julebord
      if (fromHandle === 'jul') {
        var jb = occs.find(function (o) { return slugify(o) === 'julebord'; });
        if (jb) return { value: jb, label: jb, source: 'url' };
      }
      if (fromHandle === 'uspesifisert-noytralt') {
        return { value: 'Annet', label: 'Annet', source: 'url' };
      }
    }

    var global = readGlobalOccasion();
    if (global && global.value) return { value: global.value, label: global.label || global.value, source: 'global' };
    var b = sessionBooking();
    var fromBooking = occasionName(b && b.anledning);
    if (fromBooking) return { value: fromBooking, label: fromBooking, source: 'booking', booking: b };
    return { value: '', label: '', source: '', booking: b };
  }

  function mount() {
    var root = document.querySelector('[data-fb-tilvalg-filters]');
    if (!root) return;
    var handle = collectionHandle(root);
    if (!handle) return;

    var parsed = parseCategory(handle);
    var parentHandle = (parsed && parsed.parentHandle) || handle;
    var audience = getAudience();
    var occs = pillsForAudience(audience);
    var resolved = resolveCurrent(occs, handle);
    var current = resolved.value;
    var available = parseAvailability(root);

    function occasionUsable(label) {
      if (!available) return true;
      var target = occasionCollectionHandle(parentHandle, label);
      return !!available[target];
    }

    function renderPills() {
      audience = getAudience();
      occs = pillsForAudience(audience);
      var html = '<div class="fb-tvf">';
      html += '<p class="fb-tvf__label">Filtrer etter anledning</p>';
      html += '<div class="fb-tvf__pills" role="list">';

      var alleUrl = occasionCollectionUrl(parentHandle, '');
      html += '<a class="fb-tvf__pill' + (!current ? ' is-on' : '') + '" href="' + alleUrl + '" data-fb-tvf-occ="">Alle</a>';

      occs.forEach(function (o) {
        if (o !== current && !occasionUsable(o)) return;
        var url = occasionCollectionUrl(parentHandle, o);
        html += '<a class="fb-tvf__pill' + (o === current ? ' is-on' : '') + '" href="' + url + '" data-fb-tvf-occ="' +
          o.replace(/"/g, '&quot;') + '">' + o.replace(/</g, '&lt;') + '</a>';
      });

      if (current && occs.indexOf(current) === -1 && occasionUsable(current)) {
        var extraUrl = occasionCollectionUrl(parentHandle, current);
        html += '<a class="fb-tvf__pill is-on" href="' + extraUrl + '" data-fb-tvf-occ="' +
          current.replace(/"/g, '&quot;') + '">' +
          (resolved.label || current).replace(/</g, '&lt;') + '</a>';
      }

      html += '</div>';
      if (resolved.booking && resolved.booking.order && resolved.source === 'booking') {
        html += '<p class="fb-tvf__hint">Basert på booking #' + String(resolved.booking.order).replace(/^#/, '') +
          (resolved.booking.anledning ? ' · ' + occasionName(resolved.booking.anledning) : '') + '</p>';
      } else if (current && resolved.source === 'url') {
        html += '<p class="fb-tvf__hint">Viser kolleksjon for ' + (resolved.label || current).replace(/</g, '&lt;') + '</p>';
      } else if (current) {
        html += '<p class="fb-tvf__hint">Samme anledning som i header</p>';
      }
      html += '</div>';
      root.innerHTML = html;
    }

    root.addEventListener('click', function (e) {
      var link = e.target.closest('a[data-fb-tvf-occ]');
      if (!link) return;
      var occ = link.getAttribute('data-fb-tvf-occ') || '';
      writeGlobalOccasion(occ || null, occ || null);
      document.dispatchEvent(new CustomEvent('fb:occasion-change', {
        detail: { value: occ || null, label: occ || null, source: 'filters' },
      }));
      // Let the browser follow href to the collection URL.
    });

    document.addEventListener('fb:occasion-change', function (e) {
      var d = e.detail || {};
      if (d.source === 'filters') return;
      current = d.value || '';
      resolved = { value: current, label: d.label || current, source: d.source || 'global', booking: resolved.booking };
      renderPills();
    });

    document.addEventListener('fb:audience-change', function () {
      setTimeout(function () {
        resolved = resolveCurrent(pillsForAudience(getAudience()), handle);
        current = resolved.value;
        renderPills();
      }, 0);
    });

    renderPills();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
